import API_CLIENT from "../../utils/Api";

export const GetCategories = async () => {
  return await API_CLIENT.get(`/categories`);
};
